// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Законопроєкти» (Bills, ключ `bill`, група `legislation`). */
export const billsManifest: IModuleManifest = {
  key: 'bill',
  group: 'legislation',
  slug: 'draft-bills',
  prefix: 'BILL',
  name: { en: 'Bills', uk: 'Законопроєкти' },
  entities: [
    { key: 'bill', slug: 'bill', name: { en: 'Bills', uk: 'Законопроєкти' }, main: true },
    { key: 'amendment', slug: 'amendment', name: { en: 'Amendments', uk: 'Поправки' }, main: false },
    { key: 'bill_author', slug: 'bill-author', name: { en: 'Bill Authors', uk: 'Автори' }, main: false },
    { key: 'bill_version', slug: 'bill-version', name: { en: 'Bill Versions', uk: 'Версії' }, main: false },
    { key: 'bill_reading', slug: 'bill-reading', name: { en: 'Bill Readings', uk: 'Читання' }, main: false },
    { key: 'bill_committee_assignment', slug: 'bill-committee-assignment', name: { en: 'Bill Committee Assignments', uk: 'Призначення комітетів' }, main: false },
    { key: 'bill_document', slug: 'bill-document', name: { en: 'Bill Documents', uk: 'Документи' }, main: false },
    { key: 'bill_status', slug: 'bill-status', name: { en: 'Bill Statuses', uk: 'Статуси' }, main: false },
    { key: 'amendment_change', slug: 'amendment-change', name: { en: 'Article changes', uk: 'Зміни до статей' }, main: false },
    { key: 'amendment_decision', slug: 'amendment-decision', name: { en: 'Decisions', uk: 'Рішення' }, main: false },
  ],
  loadState: () => import('./state/billsSlice').then((m) => m.billsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
